import { render, staticRenderFns } from "./EventDescription.vue?vue&type=template&id=7b3c32de"
import script from "./EventDescription.js?vue&type=script&lang=js&external"
export * from "./EventDescription.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports